import axios from 'axios';
import { httpClient } from './http-client';
import { API_ENDPOINTS } from '../config/api';

export interface SalesPlanBreed {
  id: number;
  nameRu: string;
  nameKz: string;
  nameEn: string;
}

export interface SalesPlanItem {
  region: string | null;
  sexAgeGroup: string;
  headCount: number | null;
  birthYear: string | null;
  category: string | null;
  averageWeight: string | null;
  averagePrice: string | null;
  askingPrice: string | null;
  notes: string | null;
}

export interface SalesPlanSummary {
  id: number;
  breed: SalesPlanBreed;
  periodFrom: string;
  periodTo: string;
  notes: string | null;
  isPublished: boolean;
  itemsCount: number;
  updatedAt: string | null;
}

export interface SalesPlan extends SalesPlanSummary { items: SalesPlanItem[] }
export interface SaveSalesPlan {
  breedId: number;
  periodFrom: string;
  periodTo: string;
  notes: string | null;
  isPublished: boolean;
  items: SalesPlanItem[];
}

const base = API_ENDPOINTS.SALES_PLAN;
export const salesPlanService = {
  breeds: () => httpClient.get<SalesPlanBreed[]>(`${base}/breeds`),
  list: (breedId?: number) => httpClient.get<SalesPlanSummary[]>(`${base}/admin`, { params: { breedId } }),
  get: (id: number) => httpClient.get<SalesPlan>(`${base}/admin/${id}`),
  create: (body: SaveSalesPlan) => httpClient.post<SalesPlan>(base, body),
  update: (id: number, body: SaveSalesPlan) => httpClient.put<SalesPlan>(`${base}/${id}`, body),
  delete: (id: number) => httpClient.delete(`${base}/${id}`),
};

export function salesPlanError(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    if (typeof data?.message === 'string') return data.message;
    if (data?.errors) return Object.values(data.errors).flat().join(' ');
  }
  return error instanceof Error ? error.message : 'Не удалось выполнить запрос. Попробуйте ещё раз.';
}
